var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6783",
    "data-name": "Rectangle 6783",
    width: 24,
    height: 24,
    fill: "#292929"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_111",
    "data-name": "Mask Group 111",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_002-telephone",
    "data-name": "002-telephone",
    d: "M23.192,17.292,20.23,14.33a2.48,2.48,0,0,0-1.8-.83,2.585,2.585,0,0,0-1.823.82l-1.716,1.716c-.145-.08-.291-.155-.431-.225-.187-.094-.37-.187-.534-.291a18.649,18.649,0,0,1-4.444-4.045A10.808,10.808,0,0,1,8,9.15c.45-.413.877-.839,1.27-1.247.145-.155.3-.309.455-.459A2.618,2.618,0,0,0,10.578,5.6,2.583,2.583,0,0,0,9.73,3.759L8.258,2.287c-.169-.169-.328-.333-.492-.5l-.009-.009c-.319-.328-.661-.68-1-.994A2.571,2.571,0,0,0,4.949,0,2.624,2.624,0,0,0,3.13.792L1.283,2.639A3.878,3.878,0,0,0,.125,5.123,9.309,9.309,0,0,0,.814,9.113a23.221,23.221,0,0,0,4.12,6.872h0a25.33,25.33,0,0,0,8.433,6.6,13.283,13.283,0,0,0,4.739,1.4h.014c.112,0,.216.009.328.009a3.979,3.979,0,0,0,3.084-1.327.268.268,0,0,0,.033-.037,12.064,12.064,0,0,1,.872-.9l.07-.066c.281-.267.5-.487.7-.694A2.476,2.476,0,0,0,23.192,17.292ZM8.174,7.041c-.422.427-.82.83-1.256,1.214l-.028.028a1.053,1.053,0,0,0-.267,1.191c0,.009,0,.019.009.023s0,.009,0,.014l0,0a11.692,11.692,0,0,0,1.744,2.841,19.761,19.761,0,0,0,4.777,4.35c.183.117.37.211.553.3l.108.056a5.791,5.791,0,0,1,.534.291l.009,0,.023.014a.269.269,0,0,1,.033.019,1.134,1.134,0,0,0,.52.136,1.12,1.12,0,0,0,.8-.361l1.847-1.847a1.223,1.223,0,0,1,.839-.413,1.171,1.171,0,0,1,.806.413L22.213,18.3a1.1,1.1,0,0,1-.019,1.73c-.216.23-.441.45-.652.652l-.056.056a13.579,13.579,0,0,0-.98,1.022,2.619,2.619,0,0,1-2.048.867c-.08,0-.164,0-.248-.009a11.814,11.814,0,0,1-4.219-1.266A23.828,23.828,0,0,1,6.022,15.1,21.894,21.894,0,0,1,2.141,8.639a7.885,7.885,0,0,1-.614-3.4,2.521,2.521,0,0,1,.759-1.622L4.119,1.786a1.236,1.236,0,0,1,.844-.394,1.19,1.19,0,0,1,.825.4c.286.262.553.539.839.83l.131.136c.084.089.169.173.258.262s.169.173.258.263L8.746,4.758a1.246,1.246,0,0,1,.436.858,1.246,1.246,0,0,1-.436.858c-.075.075-.155.155-.23.234s-.155.155-.23.23Z",
    transform: "translate(-0.061)",
    fill: "#292929"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPhone);
export default __webpack_public_path__ + "static/media/contact_phone.b08772c457a523b14320a7736ab46593.svg";
export { ForwardRef as ReactComponent };